import React from 'react';
import styled from '@emotion/styled';
import { useSpringCarouselContext } from '../../hooks/useSpringCarousel';
const StyledCircleThumb = styled.button `
  background: ${({ theme, darkThumbs }) => darkThumbs ?
    theme.colors.backgrounds.primaryNavigation.background :
    theme.colors.backgrounds.primaryNavigation.text[0]};
  opacity: 0.24;
  border: none;
  box-sizing: content-box;
  cursor: pointer;
  height: 2px;
  width: 20px;
  margin: 0 3px;
  text-indent: 100%;
  outline: none;
  overflow: hidden;
  padding: 0;
  transition: background 0.2s;
  white-space: nowrap;

  ${({ active }) => active && `
       opacity: 1;
    `}
`;
const CircleThumb = ({ id, itemId, onClick, darkThumbs }) => {
    const { getIsActiveItem } = useSpringCarouselContext();
    const isActive = getIsActiveItem(itemId);
    return (React.createElement(StyledCircleThumb, { id: id, active: isActive, onClick: onClick, role: "tab", "aria-selected": isActive, tabIndex: isActive ? -1 : 0, darkThumbs: darkThumbs }));
};
export default CircleThumb;
